import { FC } from "react";
import { Edit } from "@mui/icons-material";
import { Button, styled } from "@mui/material";

const EditButton = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

interface EditCardProps {
  onClick?: () => void;
}

const EditCard: FC<EditCardProps> = ({ onClick }) => (
  <EditButton variant="outlined" onClick={onClick}>
    <Edit />
  </EditButton>
);

export default EditCard;
